/*
  NUDIENT: Hela bilden eller filmen är klickbar till samma mål som
  sektionens knapp, beslutat av Vidar 29 oktober 2026, M-136.

  - Bilden eller filmen har data-nudient-media-link, och sektionens första
    knapp har data-nudient-media-target, på länken eller runt den. Utan knapp
    sätts ingen markering, och bilden är inte klickbar.
  - Knappen letas i närmaste data-nudient-media-scope, annars i bilden
    själv. I bildparet är varje halva sitt eget område, med sin egen knapp.
  - Ett klick på bilden klickar på den riktiga länken. Då följer allt som
    länken gör med, till exempel modellen i adressen, M-127, och det finns
    bara en länk för skärmläsare och tangentbord. Bilden får ingen egen
    länk.
  - Klick på länkar, knappar, fält, modellväljaren, hjältens väljarruta och
    filmens knappar gör det de gjorde förut. Markerad text följer inte med
    som klick.
  - Cmd, Ctrl eller Skift och mittenknappen öppnar målet i en ny flik, som
    en vanlig länk.
  - Laddas på alla sidor av snippets/nudient-tokens.liquid. Muspekaren står
    i assets/nudient-controls.css.

  Värden som inte är tokens:
  - data-nudient-media-link, data-nudient-media-target och
    data-nudient-media-scope: kopplingarna i sektionerna.
  - Väljaren INTERACTIVE: allt som har ett eget klick.
  - _blank och noopener: en ny flik, som en vanlig länk.
  - 0 och 1 i button: vänster- och mittenknappen.
*/

const INTERACTIVE =
  'a, button, input, select, textarea, label, summary, [role="button"], [contenteditable], nudient-model-picker, nudient-hero-gate, nudient-video-controls';

/** Sektionens första knapp för bilden. */
function targetFor(media) {
  const scope = media.closest('[data-nudient-media-scope]') ?? media;
  return scope.querySelector('a[data-nudient-media-target][href], [data-nudient-media-target] a[href]');
}

/** Bilden som klicket gäller, eller null om klicket ska göra det det gjorde förut. */
function mediaFor(event) {
  const element = event.target instanceof Element ? event.target : null;
  const media = element?.closest('[data-nudient-media-link]');
  if (!media || element.closest(INTERACTIVE)) return null;
  if (String(window.getSelection?.() ?? '')) return null;
  return media;
}

document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0) return;
  const media = mediaFor(event);
  const link = media && targetFor(media);
  if (!link) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey) {
    window.open(link.href, '_blank', 'noopener');
    return;
  }
  link.click();
});

document.addEventListener('auxclick', (event) => {
  if (event.button !== 1) return;
  const media = mediaFor(event);
  const link = media && targetFor(media);
  if (link) window.open(link.href, '_blank', 'noopener');
});
